import { render } from "./ListaMostradorPage.vue?vue&type=template&id=776b6a60&scoped=true"
import script from "./ListaMostradorPage.vue?vue&type=script&lang=js"
export * from "./ListaMostradorPage.vue?vue&type=script&lang=js"

import "./ListaMostradorPage.vue?vue&type=style&index=0&id=776b6a60&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776b6a60"]])

export default __exports__